import { createAction, props } from '@ngrx/store';
import { ProductCategory } from './models/ProductCategory';
import { ProductDescription } from './models/ProductDescription';
import { DangerousGoodsCode } from './models/DangerousGoodsCode';

// Actions for productsCategories
export const loadProductCategories = createAction(
    '[ProductsCategories] Load Product Categories',
    props<{ freightpayerId: number }>()
);

export const loadProductCategoriesSuccess = createAction(
    '[ProductsCategories] Load Product Categories Success',
    props<{ categories: ProductCategory[] }>()
);

export const loadProductCategoriesFailure = createAction(
    '[ProductsCategories] Load Product Categories Failure',
    props<{ error: string }>()
);

// Actions for productDescriptions
export const loadProductDescriptions = createAction(
    '[ProductDescriptions] Load Product Descriptions'
);

export const loadProductDescriptionsSuccess = createAction(
    '[ProductDescriptions] Load Product Descriptions Success',
    props<{ descriptions: ProductDescription[] }>()
);

export const loadProductDescriptionsFailure = createAction(
    '[ProductDescriptions] Load Product Descriptions Failure',
    props<{ error: string }>()
);

export const loadDangerousGoodsCodes = createAction(
    '[DangerousGoodsCodes] Load Dangerous Goods Codes'
);

export const loadDangerousGoodsCodesSuccess = createAction(
    '[DangerousGoodsCodes] Load Dangerous Goods Codes Success',
    props<{ dangerousGoodsCodes: DangerousGoodsCode[] }>()
);

export const loadDangerousGoodsCodesFailure = createAction(
    '[DangerousGoodsCodes] Load Dangerous Goods Codes Failure',
    props<{ error: string }>()
);